import React from 'react';
import {Logo, LogoContainer} from './styles';
import DefaultLogo from '../../assets/icons/Logo.png';

export default ({
  mTop = '0',
  link = '/teams/card',
  mWidth = '900px',
  mHeight = '50px',
  src = DefaultLogo,
}: {
  src?: string;
  link?: string;
  mTop?: string;
  mWidth?: string;
  mHeight?: string;
}) =>
  link ? (
    <LogoContainer to={link}>
      <Logo src={src} alt="Logo de team" mWidth={mWidth} mHeight={mHeight} mTop={mTop} />
    </LogoContainer>
  ) : (
    <Logo src={src} alt="Logo de team" mWidth={mWidth} mHeight={mHeight} mTop={mTop} />
  );
